import type { CTRL_SCHEMA } from "@repo/sdk/types";
import { useHttp, type HttpConfiguration } from "@repo/utils/hooks";
import { useCtrlClient } from "../contexts/CtrlApiProvider";

export type K8SSnapshot = CTRL_SCHEMA["K8SSnapshot"];
export type K8SSnapshotNode = CTRL_SCHEMA["K8SSnapshotNode"];
export type K8SDiskPool = CTRL_SCHEMA["K8SDiskPool"];

export function useSnapshots(config?: HttpConfiguration) {
  const client = useCtrlClient();

  return useHttp<K8SSnapshot[]>(
    "snapshots",
    async () => {
      return await client.getSnapshots();
    },
    config
  );
}

export function useSnapshotsTree(config?: HttpConfiguration) {
  const client = useCtrlClient();

  return useHttp<K8SSnapshotNode[]>(
    "snapshots/tree",
    async () => {
      return await client.getSnapshotsTree();
    },
    config
  );
}

export function useDiskPools(config?: HttpConfiguration) {
  const client = useCtrlClient();

  return useHttp<K8SDiskPool[]>(
    "snapshots/diskpool",
    async () => {
      return await client.getDiskPools();
    },
    config
  );
}
